import { simpleSet } from '@r/reducers/utils';

const setOrthographicMode = simpleSet as redux.reducers.flags.orthographicMode;
export const orthographicMode = setOrthographicMode(
  'SET_ORTHOGRAPHIC_MODE',
  false
);
